import { PlatformLocation } from '@angular/common';
import { Component, Inject, Optional } from '@angular/core';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { CustomerModalBaseComponent } from '../shared/customer-modal-base.component';

export class HistoricalAttributesContext {
    constructor(public customerNumberId: number) {}
}

@Component({
    templateUrl: './historical-customer-attributes-modal.html'
})
export class HistoricalCustomerAttributesModalComponent extends CustomerModalBaseComponent {
    customerNumberId: number;

    constructor(public location: PlatformLocation,
        public dialogRef: MatDialogRef<HistoricalCustomerAttributesModalComponent>,
        @Optional() @Inject(MAT_DIALOG_DATA) public data: HistoricalAttributesContext,
        public modalService: MvdModalService) {
        super(modalService);

        this.customerNumberId = this.data.customerNumberId;

        location.onPopState(() => {
            this.dialogRef.close();
        });
    }

    ngOnInit() { }

    public cancel() {
        this.dialogRef.close();
    }
}
